import React, { useState, useRef, useEffect, setTimeOut } from "react";
import axios from "axios";
import { IoClose } from "react-icons/io5";

const EmiModal = ({ setEMI, data }) => {
  const [copyText, setCopyText] = useState(true);
  const [clickDownload, setClickDownload] = useState(false);
  const qrRef = useRef();
  const [succesState, setSuccesState] = useState(false);
  const [password, setPassword] = useState("");
  const [imageLoading, setImageLoading] = useState(false);

  const data1 = {
    "2023-10-01": 30,
    "2023-11-01": 30,
    "2023-12-01": 30,
    "2023-10-04": 30,
    "2021-11-01": 30,
    "2022-12-01": 30,
    "2024-10-04": 30,
    "2622-12-01": 30,
    "2924-10-04": 30,
  };
  return (
    <div className="overlay z-50">
      <div
        className={`modal !w-[367px]  !justify-normal  relative   !max-h-[422px] !h-auto `}
      >
        <div className=" flex justify-between w-full items-center ">
          <p className=" text-base font-bold">Successful EMIs</p>
          <p onClick={() => setEMI(false)} className="  cursor-pointer">
            <IoClose
              style={{
                width: "20px",
                height: "20px",
              }}
            />
          </p>
        </div>
        <div className=" mt-2 overflow-auto">
          {Object.keys(data).map((key, index) => {
            return (
              <div
                className={` w-full justify-between ${
                  index !== 0 && "pt-4"
                } font-medium`}
              >
                <div className=" flex justify-between w-full">
                  <p className="text-xs text-[#8b8b8b]">EMI Date</p>
                  <p className="text-xs text-[#8b8b8b]">EMI Amount</p>
                </div>
                <div className=" flex justify-between w-full mt-1">
                  <p className="text-xs">{key || "--"}</p>
                  <p className="text-xs">₹ {data[key]}</p>
                </div>
              </div>
            );
          })}
        </div>
      </div>
    </div>
  );
};

export default EmiModal;
